import { OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DashboardService } from '../../dashboard';
import { Data } from '../../helpers';
import * as moment from 'moment';
import { ErrorHandlerService } from '../../services';
var AttendeesComponent = /** @class */ (function () {
    function AttendeesComponent(data, dashboardService, errorHandlerService, router, route) {
        this.data = data;
        this.dashboardService = dashboardService;
        this.errorHandlerService = errorHandlerService;
        this.router = router;
        this.route = route;
        this.showSpinner = false;
        this.showOnlyOverlay = false;
        this.showRequestReco = false;
        this.inviteCourse = false;
        this.invitecourse = false;
        this.reqforrcmd = false;
        this.query = '';
        this.sendMsg = false;
        this.msgData = {};
        this.courseDetail = {};
        this.creator = {};
        this.startTime = {};
        this.endTime = {};
        this.users = [];
        this.reqRcmd = { requestTo: {}, requestFrom: {} };
        this.rating = { responseTo: {}, responseFrom: {}, rating: {} };
        this.invitereq = { requestTo: {}, requestFrom: {} };
        this.viewProfile = {};
        this.msgTitle = "";
        this.msgContent = "";
        this.popUp = false;
        this.inviteData = {};
        this.invitee = "";
        this.allcourses = [];
        this.allcoursesdata = {};
        this.searchData = {};
        this.userData = {};
        this.queId = 0;
        this.subscriptions = [];
    }
    AttendeesComponent.prototype.editDisplay = function (edit) {
        if (edit) {
            return "block";
        }
        else {
            return "none";
        }
    };
    AttendeesComponent.prototype.ngOnInit = function () {
        this.fnInit();
    };
    AttendeesComponent.prototype.fnInit = function () {
        var _this = this;
        this.showSpinner = true;
        var s1 = this.dashboardService.userSummary1().subscribe(function (data) {
            _this.userData = data;
            _this.userId = data.userDetailsId;
            _this.invitereq.requestFrom.userDetailsId = data.userDetailsId;
            _this.reqRcmd.requestFrom.userDetailsId = data.userDetailsId;
            _this.rating.responseFrom.userDetailsId = data.userDetailsId;
        }, function (error) {
            _this.handleError(error);
        });
        this.subscriptions.push(s1);
        var s2 = this.dashboardService.onlineCoursesLite().subscribe(function (data) {
            _this.allcoursesdata = data;
            _this.allcourses = data;
        }, function (error) {
            _this.handleError(error);
        });
        this.subscriptions.push(s2);
        var s3 = this.route.queryParams.subscribe(function (params) {
            _this.query = params['courseId'] || 0;
            _this.queId = params['queId'] || 0;
            console.log('The courseId in view attendees =>' + _this.query);
            if (_this.query != '0') {
                _this.dashboardService.getAttendees(_this.query).subscribe(function (data) {
                    _this.showSpinner = false;
                    _this.courseDetail = data;
                    _this.creator = data.creator;
                    _this.users = data.users;
                    if (_this.userId != undefined) {
                        if (_this.userId == data.creator.userDetailsId) {
                            _this.invitecourse = true;
                        }
                    }
                    else {
                        if (_this.dashboardService.userdata.userDetailsId == data.creator.userDetailsId) {
                            _this.invitecourse = true;
                        }
                    }
                    _this.users.sort(function (a, b) {
                        if (a.firstName < b.firstName) {
                            return -1;
                        }
                        if (a.firstName > b.firstName) {
                            return 1;
                        }
                        return 0;
                    });
                }, function (error) {
                    _this.handleError(error);
                });
            }
        });
        this.subscriptions.push(s3);
    };
    AttendeesComponent.prototype.searchClick = function () {
        var _this = this;
        this.searchData.courseId = this.query;
        var s4 = this.dashboardService.searchAttendees(this.searchData).subscribe(function (data) {
            _this.users = data;
            _this.users.sort(function (a, b) {
                if (a.firstName < b.firstName) {
                    return -1;
                }
                if (a.firstName > b.firstName) {
                    return 1;
                }
                return 0;
            });
        }, function (error) {
            _this.handleError(error);
        });
        this.subscriptions.push(s4);
    };
    AttendeesComponent.prototype.inviteUser = function (userData) {
        var url = location.href;
        this.invitee = userData.firstName + " " + userData.lastName;
        this.inviteData.emailIds = [userData.userDetailsId];
        this.inviteData.subject = "Invitation to join " + userData.firstName + " " + userData.lastName + "'s session";
        this.inviteData.url = url.replace("attendees", "viewsession");
        console.log(this.inviteData);
        this.inviteCourse = true;
    };
    AttendeesComponent.prototype.sendInviteCourse = function () {
        var _this = this;
        var s5 = this.dashboardService.courseInvite(this.inviteData).subscribe(function (data) {
            _this.inviteCourse = false;
            _this.createInfoAlert('Course Invitation Request sent successfully!!');
        }, function (error) {
            _this.inviteCourse = false;
            _this.handleError(error);
        });
        this.subscriptions.push(s5);
    };
    AttendeesComponent.prototype.rcmdReq = function () {
        var _this = this;
        this.reqRcmd.userRequestType = 'RECOMMENDATION_REQUEST';
        var s6 = this.dashboardService.rcmdRequest(this.reqRcmd).subscribe(function (data) {
            _this.showRequestReco = false;
            _this.reqRcmd.userRequestText = '';
            _this.createInfoAlert('Recommendation Request sent successfully!!');
            _this.fnInit();
        }, function (error) {
            _this.showRequestReco = false;
            _this.handleError(error);
        });
        this.subscriptions.push(s6);
    };
    AttendeesComponent.prototype.ratingUser = function (user) {
        var _this = this;
        if (this.rating.rating.ratingText == null || this.rating.rating.ratingText == '' || this.rating.rating.ratingText == undefined) {
            this.createInfoAlert("Please select a rating from Best/Fair/Good.");
            return;
        }
        this.showSpinner = true;
        this.rating.userResponseType = 'RATING_RESPONSE';
        //console.log(this.rating);
        var s7 = this.dashboardService.rating(this.rating).subscribe(function (data) {
            _this.rating.rating.ratingText = "";
            user.ratingStatus = 'RATING_ALREADY_SENT';
            _this.showSpinner = false;
            _this.createInfoAlert("Rating submitted successfully!!");
            user.ratethis = false;
        }, function (error) {
            user.ratethis = false;
            _this.showSpinner = false;
            _this.handleError(error);
        });
        this.subscriptions.push(s7);
    };
    AttendeesComponent.prototype.sendInvite = function (id) {
        var _this = this;
        this.invitereq.userRequestText = "Invitation Request sent by User Id " + this.invitereq.requestFrom.userDetailsId + " to User Id " + id + ". Sent by REST Service.";
        this.invitereq.requestTo.userDetailsId = id;
        this.invitereq.userRequestType = 'INVITATION_REQUEST';
        console.log(this.invitereq);
        var s8 = this.dashboardService.sendInvitationReq(this.invitereq).subscribe(function (data) {
            _this.createInfoAlert('Invitation Request sent successfully!!');
            _this.fnInit();
        }, function (error) {
            _this.handleError(error);
        });
        this.subscriptions.push(s8);
    };
    AttendeesComponent.prototype.sendMessg = function (data) {
        this.viewProfile = data;
        this.sendMsg = true;
    };
    AttendeesComponent.prototype.sendMessage = function () {
        var _this = this;
        this.msgData.usersInTo = [this.viewProfile.userDetailsId];
        var s9 = this.dashboardService.inboxSendMsg(this.msgData).subscribe(function (data) {
            _this.sendMsg = false;
            _this.msgData.messageBody = '';
            _this.createInfoAlert('Message sent successfully!!');
        }, function (error) {
            _this.handleError(error);
            _this.sendMsg = false;
        });
        this.subscriptions.push(s9);
    };
    AttendeesComponent.prototype.acceptInvite = function (id) {
        var _this = this;
        var s10 = this.dashboardService.connAccept(id).subscribe(function (data) {
            _this.createInfoAlert('Invitation Request accepted successfully!!');
            _this.fnInit();
        }, function (error) {
            _this.handleError(error);
        });
        this.subscriptions.push(s10);
    };
    AttendeesComponent.prototype.downloadQuestionnaireRes = function () {
        var _this = this;
        // let loader = $("#courseId-" + courseId);
        // if (loader.css("display") == "none") {
        //   loader.css("display", "block");
        //   loader.parents("fileIconWrap").css("cursor", "default");
        //   let name = (slidedeck != null && slidedeck != undefined) ? slidedeck : 'doc';
        var csvArr = [];
        var queArr = ["Attendee"];
        var doc = this.dashboardService.getQuestionnaireAll(this.queId).subscribe(function (data) {
            for (var i = 0; i < data[0].responses.length; i++) {
                queArr.push(data[0].responses[i].question);
            }
            csvArr.push(queArr);
            for (var x = 0; x < data.length; x++) {
                var ansArr = [];
                ansArr.push(data[x].firstName + " " + ((data[x].middleName == null) ? "" : data[x].middleName + " ") + data[x].lastName);
                for (var i = 0; i < data[x].responses.length; i++) {
                    var answer = "";
                    if (data[x].responses[i].answerTypeCode == 1 ||
                        data[x].responses[i].answerTypeCode == 6) {
                        ansArr.push(data[x].responses[i].answer);
                    }
                    else if (data[x].responses[i].answerTypeCode == 2 ||
                        data[x].responses[i].answerTypeCode == 3 ||
                        data[x].responses[i].answerTypeCode == 4) {
                        for (var j = 0; j < data[x].responses[i].options.length; j++) {
                            if (data[x].responses[i].options[j].selected) {
                                ansArr.push(data[x].responses[i].options[j].value);
                                break;
                            }
                        }
                    }
                    else if (data[x].responses[i].answerTypeCode == 5) {
                        var ansString = "";
                        for (var j = 0; j < data[x].responses[i].options.length; j++) {
                            if (data[x].responses[i].options[j].selected) {
                                if (j == 0) {
                                    ansString = data[x].responses[i].options[j].value;
                                }
                                else {
                                    ansString = data[x].responses[i].answer + ", " + data[x].responses[i].options[j].value;
                                }
                            }
                        }
                        ansArr.push(ansString);
                    }
                    else if (data[x].responses[i].answerTypeCode == 7) {
                        var dd = new Date(data[x].responses[i].answer);
                        ansArr.push(moment(dd).format("MM/DD/YYYY"));
                    }
                }
                csvArr.push(ansArr);
            }
            console.log("csvArr", csvArr);
            //const header = csvArr[0];
            var csv = csvArr.map(function (row) { return row.join(','); });
            //csv.unshift(header.join(','));
            var csvArray = csv.join('\r\n');
            var a = document.createElement('a');
            var blob = new Blob([csvArray], { type: 'text/csv' });
            var url = window.URL.createObjectURL(blob);
            a.href = url;
            a.download = 'AttendeeResponse-' + _this.query + '.csv';
            a.click();
            window.URL.revokeObjectURL(url);
            a.remove();
            // loader.css("display", "none");
            // loader.parents("fileIconWrap").css("cursor", "pointer");
        }, function (error) {
            // loader.css("display", "none");
            // loader.parents("fileIconWrap").css("cursor", "pointer");
            _this.handleError(error);
        });
        this.subscriptions.push(doc);
        //}
    };
    AttendeesComponent.prototype.ngOnDestroy = function () {
        this.subscriptions.forEach(function (element) {
            element.unsubscribe();
        });
    };
    AttendeesComponent.prototype.createInfoAlert = function (alert) {
        var infoAlert = {
            isInfo: true,
            infoMessage: alert,
            url: "not required"
        };
        this.handleError(infoAlert);
    };
    AttendeesComponent.prototype.handleError = function (error) {
        console.log("The error inside the Error Handler==>" + error);
        var url = error.url;
        console.log("The URL of the error==>" + error.url);
        if (url == undefined) {
            return;
        }
        console.log("Throwing the error now. Shall call the errorHandlerService throwError method");
        this.showSpinner = false;
        this.errorHandlerService.throwError(error);
    };
    return AttendeesComponent;
}());
export { AttendeesComponent };
//# sourceMappingURL=attendees.component.js.map